module.exports = __webpack_public_path__ + "static/media/fa-regular-400.7b9568e6.svg";